<!--
 * @Description: 发送发票邮箱
 * @Version: 2.0
 * @Autor: daikeyi
 * @Date: 2020-06-05 15:25:04
 * @LastEditors: daikeyi
 * @LastEditTime: 2021-01-20 11:35:46
-->
<template>
    <div id="page_Container">
        <div id="membercenter">
            <div id="main-container">
                <div class="message">电子发票PDF元件，将以邮件方式发送至指定邮箱。</div>
                <van-cell-group>
                    <van-field v-model="email" placeholder="请输入邮箱地址" label="邮箱地址" />
                </van-cell-group>
                <div class="btns">
                    <van-button round type="primary" size="large" @click="sendEmail">发送</van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { toastLoading, clearToastLoading } from '@/utils/base/utils';
export default {
    data() {
        return {
            email: '',
            backTimeout: ''
        };
    },
    esvReady() {
        this.routerParams = this.$route.params;
    },
    methods: {
        sendEmail() {
            const invoiceEmail = this.email;
            if (!invoiceEmail) {
                this.$toast('邮箱不能为空');
                return false;
            } else if (!/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(invoiceEmail)) {
                this.$toast('请填写正确的邮箱');
                return false;
            }
            const params = { merchantOrderNo: this.routerParams.invoiceSerialNumber, invoiceEmail };
            this.$doRequest({
                url: '/invoice/pushInvoice',
                params: params,
                before: function() {
                    this.loading = toastLoading();
                },
                complete: function() {
                    clearToastLoading(this.loading);
                }
            },
            (data) => {
                this.$toast('发送成功');
                this.backTimeout = setTimeout(() => {
                    this.esvBackPage(1);
                }, 1000);
            }, (data) => {
                this.$toast('发送失败');
            });
        }
    },
    esvBack(backFn) {
        clearTimeout(this.backTimeout);
        return backFn && backFn(true);
    }
};
</script>

<style scoped lang="scss">
    .message {
        padding: 0 15px;
        line-height: 33px;
        color: $text-gray-color;
    }
    .btns {
        padding: 16px 24px;
    }
</style>
